// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsvg[data-v-fdf20474] {\n  display: inline-block;\n  vertical-align: baseline;\n  margin-bottom: -5px;\n}\n#_261_zi[data-v-fdf20474] {\n    stroke-width: 1px;\n    stroke-linejoin: miter;\n    stroke-linecap: butt;\n    stroke-miterlimit: 4;\n    shape-rendering: auto;\n}\n", ""]);
// Exports
module.exports = exports;
